(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/receipt/receipt.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/receipt/receipt.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const mapReceiptData = (wager, type) => {
  var _wager$properties;
  return {
    type: 'scratchgames',
    state: 'finished',
    title: wager.description,
    payDate: new Date(wager.regWagerTime),
    finalizedDate: new Date(wager.completedOn),
    amountTotal: wager.betAmount,
    channel: 'Internet',
    amountWin: wager.winText || wager.winAmount,
    wagerId: wager.wagerId,
    productCode: type,
    productId: (_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.externalProductId,
    isWinText: Boolean(wager.winText)
  };
};
setGlobal('svs.ticketgames.ticketUtility.components.Receipt', _ref => {
  let _ref$animationDelayMs = _ref.animationDelayMs,
    animationDelayMs = _ref$animationDelayMs === void 0 ? 2000 : _ref$animationDelayMs,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? true : _ref$show,
    fetchedGame = _ref.fetchedGame,
    ticketInfo = _ref.ticketInfo;
  const ref = useRef(null);
  const type = ticketInfo.type;
  if (!fetchedGame) {
    return null;
  }
  const receiptData = mapReceiptData(fetchedGame, type);
  const receiptHTML = svs.tb_ui.receipt.partials.receipt(receiptData);
  useEffect(() => {
    if (show && ref.current) {
      gsap.to(ref.current, {
        opacity: 1,
        duration: 2,
        delay: animationDelayMs / 1000
      });
    }
  }, [animationDelayMs, ref, show]);
  return React.createElement("div", {
    className: "receipt ticket-receipt margin-top-4",
    "data-testid": "ticket-receipt",
    id: "ticket-receipt",
    ref: ref
  }, React.createElement("div", {
    className: "receipt-table margin-2",
    dangerouslySetInnerHTML: {
      __html: receiptHTML
    }
  }), " ");
});

 })(window);